export const env = {
  apiUrl: import.meta.env.VITE_API_URL ?? 'http://localhost:5003',
  appTitle: import.meta.env.VITE_APP_TITLE ?? 'ATA Cross-Sell Referrals',
  authClientId: (import.meta.env['VITE_AUTH_CLIENT_ID'] as string) ?? '',
  authTenantId: (import.meta.env['VITE_AUTH_TENANT_ID'] as string) ?? '',
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
  mode: import.meta.env.MODE,
} as const;

export const isAuthEnabled = !!env.authClientId;
